import PropTypes from 'prop-types';
import * as moment from 'moment';
import RewardProp from '../../sections/sessions/propTypes/rewardProp';
import ImageProp from './imageProp';

const propType = {
  _id: PropTypes.string,
  name: PropTypes.string,
  description: PropTypes.string,
  slug: PropTypes.string,
  summary: PropTypes.string,
  startDate: PropTypes.number,
  endDate: PropTypes.number,
  confirmationLinkTime: PropTypes.number,
  language: PropTypes.string,
  category: PropTypes.string,
  survey: PropTypes.string,
  status: PropTypes.string,
  trainer: PropTypes.string,
  host: PropTypes.string,
  type: PropTypes.string,
  owner: PropTypes.string,
  price: PropTypes.number,
  promotionsPrice: PropTypes.number,
  minUsers: PropTypes.number,
  maxUsers: PropTypes.number,
  courses: PropTypes.arrayOf(PropTypes.string),
  targetTeams: PropTypes.arrayOf(PropTypes.string),
  targetUsers: PropTypes.arrayOf(PropTypes.string),
  participants: PropTypes.arrayOf(PropTypes.string),
  reward: PropTypes.shape(RewardProp.propType),
  journeys: PropTypes.arrayOf(PropTypes.string),
  image: PropTypes.shape(ImageProp.propType),
};

const defaultProp = {
  name: '',
  description: '',
  summary: '',
  courses: [],
  journeys: [],
  targetUsers: [],
  targetTeams: [],
  startDate: moment.utc().valueOf(),
  endDate: moment.utc().valueOf(),
  confirmationLinkTime: moment().utc().valueOf(),
  language: null,
  category: null,
  status: null,
  trainer: null,
  host: null,
  price: null,
  promotionsPrice: null,
  reward: null,
  type: null,
  image: null,
  owner: '',
  webinar: null,
  classroom: null,
  minUsers: null,
  maxUsers: null,
  survey: null,
  participants: [],
  documents: [],
};

export default { propType, defaultProp };
